import React, { Fragment, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Card, Dropdown, Badge } from "react-bootstrap";
import {
  FiUser,
  FiLink2,
  FiCalendar,
  FiEdit,
  FiBook,
  FiTarget,
  FiUpload,
} from "react-icons/fi";
import "../../assets/css/onHover.css";
import "../../assets/css/details.css";
import {
  getDepartmentList,
  deleteDepartmentUser,
  getDepartmentUsersList,
  deleteDepartment,
  updateDepartmentStatus,
  updateDepartment,
  getDepartmentDetails,
} from "../../services/Users-services";
import {
  getTutorHomeworkReviewList,
  getTutorHomeworkReviewDetails,
  updateTutorHomeworkReviewStatus,
  updateTutorHomeworkReview,
  deleteTutorHomeworkReview,
  getTutorHomeworkDetails,
  updateTutorHomeworkStatus,
  updateTutorHomework,
  deleteTutorHomework,
} from "../../services/Academic-Services";
import AddLectureToSchedule from "../FormComponents/AddLectureToSchduel";
import { useSharedState, useGlobalState } from "../../services/hostelConst.js";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import {
  getMasterActionStatusFieldName,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import MasterTable from "../../views/dashboard/widget/MasterTabel.js";
import MasterTable2 from "../../views/dashboard/widget/MasterTabe2";
import AddGroupUserForm from "../FormComponents/AddGroupuser";
import { getLocalStorageData } from "../../services/axiosComponent";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import { getMethods } from "../../services/utilityFunctions";
import AddGroupForm from "../FormComponents/AddGroups";
import AddDepartmentUser from "../DepartmentManagementCompo/AddDepartmentUser.js";
import AddDepartmentForm from "../FormComponents/AddDepartment";
import {
  openModal,
  closeModal,
  updateIds,
} from "../../services/redux/reducers/modalSlice";
import { addSection } from "../../services/redux/reducers/sectionSlice";
import { useSelector, useDispatch } from "react-redux";
import AddTutorHomeWorkForm from "../FormComponents/AddTutorHomeWork";
const TutorHomeWorkDetailsPage = ({ navigate }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const modal = useSelector((state) => state.modal);
  const sectionDetails = useSelector((state) => state.section);
  var navigate = navigate;
  const [sharedState, setSharedState] = useSharedState();

  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState({});

  const userId = getLocalStorageData("profileDetails")._ID;
  const fetchDetails = async ({ id, isLoading = true }) => {
    if (isLoading) setLoading(true);

    const response = await getTutorHomeworkDetails(id);

    if (response.status === "success") {
      console.log("response", response.data);
      dispatch(updateIds({ scheduleId: id }));
      setMethods(getMethods("Academic", "Tutor Homework"));
      setDetails(response.data);
    } else {
      showErrorMessages({ data: response, navigate });
    }
    if (isLoading) setLoading(false);
  };

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      //   openModal({ id: id });
    }
    fetchDetails({ id: id });
  }, []);

  return (
    <Fragment>
      {loading ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <Row className="mb-3">
          <Row className="mb-1 pb-0">
            <Col lg="12" className="mb-0 pb-0">
              <Card
                className="position-relative border-0 transition-all shadow-sm"
                style={{ borderRadius: "1rem", transition: "0.3s" }}
              >
                <Card.Body className="p-3 px-lg-4 py-lg-3 pe-1">
                  <Row className="">
                    {/* Left Section */}
                    <Col lg="9">
                      <div className="">
                        <DetailsPageNavigation
                          list={["Sections", "Schedule"]}
                        />
                        <div className="d-flex align-items-start gap-2 mb-1">
                          <h3
                            className="mb-0 fw-bold fs-4 text-truncate"
                            style={{
                              background:
                                "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            {details?.NAME}
                          </h3>
                          <Badge
                            bg=""
                            className=" mt-0"
                            style={{
                              padding: "4px 7px",
                              fontSize: "0.65rem",
                              fontWeight: "400",
                              backgroundColor:
                                details?.["STATUS"] === "Y"
                                  ? "#e8f5e9"
                                  : "#ffebee",
                              color:
                                details?.["STATUS"] === "Y"
                                  ? "#2e7d32"
                                  : "#c62828",
                              borderRadius: "4px",
                              textTransform: "uppercase",
                              letterSpacing: "0.4px",
                            }}
                          >
                            {details?.["STATUS"] === "Y"
                              ? "Published"
                              : "Unpublished"}
                          </Badge>
                        </div>
                        <p
                          className="text-muted mb-5"
                          style={{
                            fontSize: "0.875rem", // Reduced from fs-6 (1rem) to 0.875rem
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            opacity: 0.75, // Added for better readability
                          }}
                        >
                          {details?.DESCRIPTION +
                            "this the discription of the homework" ||
                            "No Description available"}
                        </p>

                        {/* Key Details Section - Improved Layout */}
                        <div className="d-flex flex-wrap gap-4 mb-2">
                          {/* Subject Info */}
                          <div className="d-flex align-items-center hover-animation">
                            <div
                              className="d-flex align-items-center justify-content-center rounded-circle me-2"
                              style={{
                                width: "24px",
                                height: "24px",
                                backgroundColor: "rgba(33, 150, 243, 0.15)",
                              }}
                            >
                              <FiBook
                                style={{ color: "#1976D2", fontSize: "16px" }}
                              />
                            </div>
                            <div>
                              <div
                                className="text-muted"
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "600",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Subject
                              </div>
                              <div
                                className="fw-medium"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {details?.SUBJECT || "N/A"}
                              </div>
                            </div>
                          </div>

                          {/* Score Info */}

                          {/* Tutor Info */}
                          <div className="d-flex align-items-center hover-animation">
                            <div
                              className="d-flex align-items-center justify-content-center rounded-circle me-2"
                              style={{
                                width: "24px",
                                height: "24px",
                                backgroundColor: "rgba(233, 30, 99, 0.15)",
                              }}
                            >
                              <FiUser
                                style={{ color: "#C2185B", fontSize: "16px" }}
                              />
                            </div>
                            <div>
                              <div
                                className="text-muted"
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "600",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Tutor
                              </div>
                              <div
                                className="fw-medium"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {details?.TUTOR || "N/A"}
                              </div>
                            </div>
                          </div>

                          {/* Submission Info */}
                          <div className="d-flex align-items-center hover-animation">
                            <div
                              className="d-flex align-items-center justify-content-center rounded-circle me-2"
                              style={{
                                width: "24px",
                                height: "24px",
                                backgroundColor: "rgba(255, 193, 7, 0.15)",
                              }}
                            >
                              <FiUpload
                                style={{ color: "#FFA000", fontSize: "16px" }}
                              />
                            </div>
                            <div>
                              <div
                                className="text-muted"
                                style={{
                                  fontSize: "0.7rem",
                                  fontWeight: "600",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                }}
                              >
                                Submission
                              </div>
                              <div
                                className="fw-medium"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {details?.SUBMISSION || "N/A"}
                              </div>
                            </div>
                          </div>

                          {/* Reference Info */}
                          <a
                            href={details?._REFERENCES || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            <div className="d-flex align-items-center hover-animation">
                              <div
                                className="d-flex align-items-center justify-content-center rounded-circle me-2"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: "rgba(76, 175, 80, 0.15)",
                                }}
                              >
                                <FiLink2
                                  style={{ color: "#388E3C", fontSize: "16px" }}
                                />
                              </div>
                              <div>
                                <div
                                  className="text-muted reference-text"
                                  style={{
                                    fontSize: "0.7rem",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    transition: "color 0.2s ease",
                                  }}
                                >
                                  Reference
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </Col>

                    {/* Right Section */}
                    <Col lg="3" className=" ">
                      <div className="d-flex flex-column gap-1 justify-content-between  h-100">
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small ">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiUser className="text-primary fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["CREATED BY"]}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiCalendar className="text-success fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["LAST MODIFIED"]}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                          >
                            <FiEdit className="text-warning fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["MODIFIED BY"]}
                            </div>
                          </div>
                        </div>
                        {
                          <div className="d-flex align-items-center gap-1 p-1 hover-bg-light rounded-2 small">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{ width: 28, height: 28 }}
                            >
                              <MasterActions
                                actions={{
                                  edit: true,
                                  delete: true,
                                  status: true,
                                }}
                                publish={getMasterActionStatusFieldName(
                                  "Tutor Homework"
                                )}
                                title="Homework"
                                AddForm={
                                  <AddTutorHomeWorkForm
                                    navigate={navigate}
                                    refresh={() => {
                                      fetchDetails({
                                        id: id,
                                        isLoading: false,
                                      });
                                    }}
                                  />
                                }
                                refresh={() => {
                                  fetchDetails({
                                    id: id,
                                    isLoading: false,
                                  });
                                }}
                                methods={methods}
                                deleteRow={deleteTutorHomework}
                                updateStatus={updateTutorHomeworkStatus}
                                updateRow={updateTutorHomework}
                                isDetailsPage={true}
                                item={details}
                              />
                            </div>
                            <div>
                              <div
                                className={`text-dark fw-medium`}
                                style={{ fontSize: "0.875rem" }}
                              >
                                {"Show Options"}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-0">
            <Col lg="12">
              {/* <MasterTable2
                tab1={"User Management"}
                tab2={"Department Users"}
                deleteFun={deleteDepartmentUser}
                getList={getDepartmentUsersList}
                groupLevelList={groupLevelList}
                adminId={details["_DEPARTMENT HEAD_"]["_ID"]}
                departmentId={details["_ID"]}
                columns={["DISPLAY NAME", "GROUP LEVEL"]}
                details={details}
                AddForm={AddGroupUserForm}
                actions={{
                  delete: true,
                }}
                isAdmin={details["_IS ADMIN"] == "Y" ? true : false}
                title={"Group Users"}
                methods={{ DELETE: 1 }}
                subTitle={"User"}
              /> */}

              <MasterTable
                getTableData={getTutorHomeworkReviewList}
                deleteRow={deleteTutorHomework}
                updateStatus={updateTutorHomeworkReviewStatus}
                tab1={"Academic"}
                homeworkId={id}
                tab2={"Tutor Homework Review"}
                actions={{
                  status: true,
                  edit: true,
                  delete: true,
                }}
              />
            </Col>
          </Row>
        </Row>
      )}
    </Fragment>
  );
};

export default TutorHomeWorkDetailsPage;
